import type { SyntheticEvent } from "react";
import { getIconForFile } from "vscode-icons-js";

const ICONS_PATH = `${process.env.PUBLIC_URL}/static/icons`;

// vscode-icons-js names icons the app doesn't ship under public/static/icons.
// Map those to one we do ship (ENG-2110: .webp rendered a broken image).
const MISSING_ICON_FALLBACKS: Record<string, string> = {
  "file_type_webp.svg": "file_type_image.svg",
};

export const getFileIconSrc = (fileName: string | null | undefined): string => {
  const icon =
    getIconForFile((fileName || "").toLowerCase()) || "default_file.svg";
  return `${ICONS_PATH}/${MISSING_ICON_FALLBACKS[icon] ?? icon}`;
};

// Any other icon that fails to load degrades to the generic file icon, once.
export const handleFileIconError = (e: SyntheticEvent<HTMLImageElement>) => {
  const img = e.currentTarget;
  if (img.dataset.iconFallback) return;
  img.dataset.iconFallback = "true";
  img.src = `${ICONS_PATH}/default_file.svg`;
};
